import shop from "@/api/discounts";

// initial state
const state = {
    all: [],
    discount: {}
};

// getters
const getters = {
    discount: state => {
        return state.discount;
    }
};

// actions
const actions = {
    getAllDiscounts({
        commit
    }) {
        shop.getDiscounts().then(discounts => {
            commit("getDiscounts", discounts.data);
        });
    },
    searchDiscount: async (context, discount) => {
        let d = (await shop.searchDiscount(discount)).data;
        context.commit("getDiscounts", d);
        return d;
    },
    getDiscount: async (context, id) => {
        let d = (await shop.getDiscount(id)).data;
        context.commit("getDiscount", d);
        return d;
    },
    postDiscount: async (context, discount) => {
        const result = (await shop.postDiscount(discount)).data;
        context.commit("postDiscount", result);
    },
    putDiscount: async (context, discount) => {
        const result = (await shop.putDiscount(discount)).data;
        context.commit("putDiscount", result);
    },
    deleteDiscount: async (context, discount) => {
        (await shop.deleteDiscount(discount)).data;
        context.commit("deleteDiscount", discount);
    },
    clearDiscounts: async (context) => {
        context.commit("clearDiscounts");
    }

};

// mutations
const mutations = {
    getDiscounts(state, discounts) {
        state.all = discounts;
    },
    getDiscount(state, discount) {
        //state.discount = discount
        state.discount = null;
        state.discount = Object.assign({}, state.discount, discount);
    },
    postDiscount(state, discount) {
        //state.discount = discount
        state.discount = null;
        state.discount = Object.assign({}, state.discount, discount);
    },
    putDiscount(state, discount) {
        //state.discount = discount
        state.discount = null;
        state.discount = Object.assign({}, state.discount, discount);
    },
    deleteDiscount(state, discount) {
        state.all.splice(state.all.indexOf(discount), 1);
    },
    clearDiscounts(state) {
        state.all = [];
        state.discount = {};
    },
    decrementDiscountInventory(state, {
        id
    }) {
        const discount = state.all.find(discount => discount.id === id);
        discount.inventory--;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};